import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import PreviewIcon from '../../icons/preview'

const MultiSelectPanelFooter = props => {
  const {
    onToggleOption,
    onUpdateOption,
    togglePanel,
    isExpanded,
    isExpandable,
    moreOptionCount
  } = props

  const expandableContainerClassNames = classNames(
    'search-facet-panel-toggle',
    {
      'is-expanded': isExpanded && isExpandable
    }
  )

  const expandableToggleClassNames = classNames(
    'search-facet-panel-toggle__link',
    {
      'is-expanded': isExpanded && isExpandable
    }
  )

  // only show border top when the panel is expandable
  const expandableContainerStyle = isExpandable
    ? {}
    : {
        borderTop: 0
      }

  const onSubmit = () => {
    togglePanel()
    onUpdateOption()
  }

  return (
    <div
      style={expandableContainerStyle}
      className={expandableContainerClassNames}
    >
      {isExpandable && (
        <a
          className={expandableToggleClassNames}
          href=""
          onClick={onToggleOption}
        >
          <span>
            <PreviewIcon />
            <span className="search-facet-panel-toggle__remaining">
              Show remaining {moreOptionCount} options
            </span>
          </span>
          <span>Hide options</span>
        </a>
      )}
      <div className="search-facet-panel__action">
        <button
          onClick={onSubmit}
          className="fds-c-button--3d -color-primary -width-full"
        >
          Done
        </button>
      </div>
    </div>
  )
}

MultiSelectPanelFooter.propTypes = {
  onToggleOption: PropTypes.func.isRequired,
  onUpdateOption: PropTypes.func.isRequired,
  togglePanel: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isExpandable: PropTypes.bool.isRequired,
  moreOptionCount: PropTypes.number.isRequired
}

export default MultiSelectPanelFooter



// WEBPACK FOOTER //
// ./client/components/filters/filtersPanel/multiSelectPanelFooter.js